import React, { Fragment } from 'react';

const ToggleDisplay = (props) => {

    let res;
    //we need to support hide/show...meh
    let keys = Object.keys(props);
    let key = keys[0];

    if (props[key]) {
    	res = key === 'hide' ? null :  (<Fragment>{props.children}</Fragment>);
    } else {
    	res = key === 'hide' ? (<Fragment>{props.children}</Fragment>) : null; 
    }

    return res;
};



export default ToggleDisplay;


// WEBPACK FOOTER //
// ./src/components/Common/ToggleDisplay.js